/**
 * Links to the pages that live on the public website, not in this app. This app
 * deliberately serves no second copy of a legal text - a second copy is a second
 * version of it.
 */

/** Provider details, § 5 DDG. */
export const IMPRINT_URL = "https://lyra.rocks/impressum";

/** Withdrawal instructions and model withdrawal form, § 312f Abs. 2 BGB. */
export const WITHDRAWAL_POLICY_URL = "https://lyra.rocks/widerruf";

/** Apple's subscription settings, where an App Store subscription is cancelled. */
export const APPLE_SUBSCRIPTIONS_URL =
  "https://apps.apple.com/account/subscriptions";

/** Apple's refund request page, where an App Store purchase is withdrawn. */
export const APPLE_REPORT_PROBLEM_URL = "https://reportaproblem.apple.com";

export const GOOGLE_PLAY_SUBSCRIPTIONS_URL =
  "https://play.google.com/store/account/subscriptions";

export const GOOGLE_PLAY_REFUND_URL =
  "https://support.google.com/googleplay/answer/15574897";

/** General terms and conditions. */
export const TERMS_URL = "https://lyra.rocks/agb";

/**
 * Privacy notice, Art. 13 and Art. 14 GDPR.
 *
 * ⚠️ It belongs next to every form on the two public pages, not only in the
 * footer: Art. 13 is owed at the moment the data is collected, which is while
 * the visitor is looking at the form.
 */
export const PRIVACY_URL = "https://lyra.rocks/datenschutz";

/**
 * The single contact address of the provider (imprint and AGB 24.3). Used as
 * the DSA point of contact.
 */
export const CONTACT_EMAIL = "info@eternalfoo.com";

/** Where a cancellation can be sent by email. */
export const CANCELLATION_EMAIL = "support@lyra.rocks";
